import { docReady } from "../utilities";
import Favourites from '../libraries/Favourites';
import Braze from '../libraries/Braze';
import { getQueryParam } from '../utils/queryParams';
import { load } from "@shopify/theme-sections";

import '../sections/collection-filters';

load('collection-filters');

function logAthosSearch(searchTerm, attempt = 0) {
    const resultsCount = window.athos?.controller?.search?.store?.pagination?.totalResults;
    if (typeof resultsCount === 'number') {
        Braze.logSearchPerformed({ search_term: searchTerm, results_count: resultsCount });
    } else if (attempt < 150) {
        setTimeout(() => logAthosSearch(searchTerm, attempt + 1), 100);
    } else {
        console.warn('Athos results never loaded, search_performed not sent');
    }
}

docReady(function() {
    Shopify.queryParams = {};
    if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }
    if (Shopify.queryParams.sort_by) {
        const pos = document.getElementsByClassName('collection__content')[0].getBoundingClientRect();
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual'
        }
        window.scrollTo(0, parseInt(pos.top));

    }
    const sortingSelectors = document.getElementsByClassName('collection-sorting__select');
    if (sortingSelectors.length > 0) {
        [].forEach.call(sortingSelectors, function(sortingSelector) {
            sortingSelector.addEventListener('change', function(event) {
                Shopify.queryParams.sort_by = event.target.value;
                const URLparams = Object.keys(Shopify.queryParams).map(function(k) {
                    return encodeURIComponent(k) + '=' + encodeURIComponent(Shopify.queryParams[k])
                }).join('&')
                location.search = URLparams.replace(/\+/g, '%20');
            });
        });
    }

    Favourites.init();
    Favourites.initButtons();

    const collectionEl = document.querySelector('.collection');
    const searchTerm = (getQueryParam('q') || '').trim();
    if (collectionEl && collectionEl.dataset.athosSearch === 'true' && searchTerm) {
        logAthosSearch(searchTerm);
    } else if (collectionEl && collectionEl.dataset.collectionTitle && collectionEl.dataset.collectionUrl) {
        Braze.logCategoryViewed({
            product_type: collectionEl.dataset.collectionTitle,
            category_url: collectionEl.dataset.collectionUrl,
        });
    }
});
